/* eslint-disable react/prop-types */
import React from 'react';
import {  Text, View, StyleSheet, Image } from '@react-pdf/renderer';


// Register fonts (optional)
// Font.register({
//   family: 'Roboto',
//   src: 'https://cdnjs.cloudflare.com/ajax/libs/ink/3.1.10/fonts/Roboto/roboto-light-webfont.ttf'
// });

// Create styles
const styles = StyleSheet.create({

  header: {
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: 20,
    paddingBottom: 10,
    borderBottom: '2px solid #2c3e50',
  },
  logo: {
        maxWidth: 90,
    maxHeight: 70,
    marginRight: 15,
  },
  headerText: {
    fontSize: 12,
    color: '#2c3e50',
    lineHeight: 1.4,
  }
});




const HeaderPDF = ({ user , agencyInfo}) => {
    if(!user) return null;
    
    const agency = user.company || {};
    const logo = agency.logo || '';
    const company_name = agency.name || '';
    const address = agencyInfo.agencyAddress || '';
    const phone = agencyInfo.agencyPhone || '';
   
    return (
      <View style={styles.header}>
        {logo && (
          <Image
            src={logo} // Ensure this is a full valid URL
            style={styles.logo}
          />
        )}
        <Text style={styles.headerText}>
          {company_name}
          {"\n"}
          {address} 
         
          {"\n"}
          {phone}

        </Text>
      </View>
    );
  };


export default HeaderPDF;
